import { RootState } from "@/store/store";
import { normalizedCostWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByIdSelector";

export const normalizedCostWidgetViewIdByIdSelector = (
  state: RootState,
  widgetId: string,
) => {
  return normalizedCostWidgetByIdSelector(state, widgetId)?.view_id;
};
